import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconWhiteboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWhiteboard"><Circle cx="7.5" cy="12" r="4" stroke="currentColor"/><Path d="M10.5 20.5L15 13.5L19.5 20.5H10.5Z" stroke="currentColor"/><Path d="M10.5 5.4453C10.5 5.4453 14.0139 2.53422 15.7709 3.83432C18.3891 5.77172 12.8426 8.13044 13.4283 9.20424C14.0139 10.278 17.9298 7.96162 19.8705 9.74106C21.0418 10.815 20.2993 12.3204 19.8705 13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWhiteboard;
